import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { t } from 'i18next';
import { Svgs } from '../../../../assets/svg';

const ModalTitleRow: React.FC<{
  onBack?: () => void;
  onClose: () => void;
  title: React.ReactNode;
}> = ({ onBack, onClose, title }) => {
  const showBackButton = typeof onBack === 'function';

  return (
    <Box
      sx={{
        alignItems: 'center',
        columnGap: 1,
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        minHeight: 48,
        width: '100%',
      }}>
      <Box sx={{ justifySelf: 'start', lineHeight: 0 }}>
        <IconButton
          aria-label={t('Back')}
          disabled={!showBackButton}
          onClick={onBack}
          sx={{
            padding: '2px',
            visibility: showBackButton ? 'visible' : 'hidden',
          }}>
          <Svgs.IconArrowLeft style={{ height: '40px', width: '40px' }} />
        </IconButton>
      </Box>
      <Box
        id='find-your-institution-title'
        sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', minWidth: 0 }}>
        {typeof title === 'string' ? (
          <Typography align='center' color='primary' variant='p30Bold'>
            {title}
          </Typography>
        ) : (
          title
        )}
      </Box>
      <Box sx={{ justifySelf: 'end', lineHeight: 0 }}>
        <IconButton style={{ padding: 5 }} aria-label={t('Close')} onClick={onClose}>
          <Svgs.ActionSmallCloseDefault style={{ height: '25px', width: '25px' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ModalTitleRow;
